export default __webpack_public_path__ + "static/media/bg4.b9e6c0a8.jpg";